/**
 * A random client-side id, safe outside a secure context.
 *
 * `crypto.randomUUID()` requires a secure context (HTTPS, or `localhost`), and this app's
 * subdomain-per-tenant routing (e.g. `acme.lvh.me` in local dev) is plain HTTP — so it is
 * `undefined` there even though `crypto.getRandomValues` still works, since only the former is
 * gated behind a secure context. Falling back to it rather than `Math.random()` keeps the id
 * genuinely unpredictable without needing a real UUID shape, which nothing here requires.
 */
export function generateLocalId(): string {
  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
    return crypto.randomUUID();
  }
  const bytes = new Uint8Array(16);
  crypto.getRandomValues(bytes);
  return Array.from(bytes, (byte) => byte.toString(16).padStart(2, '0')).join('');
}
